import { Directive } from '@angular/core';
import { IfCheckoutProcessDirectiveDef } from '@df/ui/common/if-checkout-process.directive.def';
export function isCheckoutProcess(url: string): boolean {
    return !!(url.match(/^\/checkout/) && !url.match(/^\/checkout\/success/));
}
@Directive({
    selector: '[ifCheckoutProcess]',
    standalone: true
})
export class IfCheckoutProcessDirective extends IfCheckoutProcessDirectiveDef {
    protected override check(): boolean {
        return isCheckoutProcess(this.router.url);
    }
}
